
import React from 'react';
import SetoCanvasPage from 'pages/SetoCanvasPage';
import {useState, useEffect, useRef} from 'react';
import PriceLabel from 'views/product/PriceLabel';

import {Img, Button, Separator, SCSlider} from 'views/AppElements';
import MusicPlaqueForm from 'views/order/MusicPlaqueForm';
import AppConstants from 'AppConstants';

import ProductAPI from 'service/api/ProductAPI';
import ProductStore from 'stores/ProductStore';

import Input from 'muicss/lib/react/input';

import {useProduct} from 'hooks/ProductHook';
import SuggestedProducts from 'views/product/SuggestedProducts';

const PRODUCT_TYPES = AppConstants.PRODUCT_TYPES;


const MusicPlaqueStyleForm = ({selectedProduct, availableProducts, onProductSelect, onCustomizeNow, onChangeQuantity}) => {

    const productLabels = availableProducts.filter(p => p !== null)
                                        .map((p,index) => {
                                            let checkedLabel = <span><i className="fa fa-square-o" aria-hidden="true"></i> </span>;
                                            let checked = selectedProduct !== null && selectedProduct.id === p.id;
                                            if(checked)
                                                checkedLabel = <span className="checkedlabel"><i className="fa fa-check-square" aria-hidden="true"></i> </span>

                                            return <Button key={"productLabel_"+index} className={checked? "checkedLabelBtn": ""} onClick={() => onProductSelect(p, index)} mui="true">{checkedLabel}{p.title}</Button>;
                                        } )

    const displayProduct = selectedProduct === null? availableProducts[0]: selectedProduct;

    return (<div className="flexColumn" id="musicPlaqueStyleForm">
        <h1 className='flexColumn productTitle'>
            <span>CUSTOM MUSIC PLAQUE</span>
        </h1>
        <p style={{display: 'block', color: 'gray', margin: '15px 0px 0 0', fontSize: '120%', whiteSpace: 'pre-line'}}>
                - Design your own Music Plaque. Gift something personal and express your sentiment through your favourite Music/Song.
        </p>
        {
            displayProduct &&
            <PriceLabel style={{margin: '15px 0px 25px 0', fontWeight: 'bold', fontSize: '26px', display: 'block', color: '#f8951b'}} 
                                price={displayProduct.price} 
                                aliasPrice={displayProduct.aliasPrice}
                                productType={displayProduct.productType} invertColor={true} discountFont="65%" />
        }
        <h4 style={{margin: 0}}>Quantity:</h4>
        <div><Input defaultValue={1} onChange={(event) => {
            onChangeQuantity(event.target.value);
        }}/></div>

        <h4 style={{margin: '10px 0 0 0'}}>Plaque Size:</h4>
        <div><Input style={{color: 'gray'}} disabled={true} defaultValue={PRODUCT_TYPES.MUSIC_PLAQUE.SIZE.A4.label} /></div>

        <h4 style={{margin: '10px 0 0 0'}}>Select Style:</h4>
        <div className="flexRow" style={{margin: '10px 0'}} id="productLabels">
            {productLabels}
        </div>
        

        <Button mui="true" variant="primary" disabled={selectedProduct === null} onClick={onCustomizeNow}>Customize Now</Button>

        <Separator style={{margin: '20px auto'}}/>

        <ul id="plaqueFormInfo">
            <li>Select your style of Music Plaque: Acryclic or Framed.</li>
            <li>Enter Song and Artist of your choice.</li>
            <li>Upload the image you want on your Music Plaque.</li>
            <li>Place your order and get it delivered on your Doorstep.</li>
        </ul>
    </div>)
};


const MusicPlaquePreview = ({product}) => {
    if(product === null)
        return <Img className="largeImg" src={null} />;

    return <Img className="largeImg" src={product? product.previewImage: null} />;
}

function MusicPlaqueMaker(props) {
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [quantity, setQuantity] = useState(1);

    const previewSliderRef = useRef();
    const componentSliderRef = useRef();
    const customProductIds = AppConstants.CUSTOM_PRODUCTS[PRODUCT_TYPES.MUSIC_PLAQUE.val];
    
    const products = customProductIds.map(id => useProduct(id));
    const photoFrameUrl = PRODUCT_TYPES.PHOTO_FRAME.url;
    const [suggestedProducts, setSuggestedProducts] = useState(ProductStore.getProductsByType(photoFrameUrl));

    useEffect(() => {
        const listener = ProductStore.addListener(() => {
			setSuggestedProducts(ProductStore.getProductsByType(photoFrameUrl));
		});

        if(suggestedProducts === null) {
            ProductAPI.getProductsByType(PRODUCT_TYPES.PHOTO_FRAME, 0, AppConstants.DEFAULT_PRODUCT_PAGE_SIZE);	
        }

        return () => listener.remove();
	}, []);

    const previewSliderSettings = {
        customPaging: function(i) {
            if(products[i] === null)
                return <div></div>

          return (
            <img src={products[i].previewImage} alt="Order your custom Music Plaque in Nepal from setocanvas.com" />
          );
        },
        beforeChange: (current, next) => setSelectedProduct(products[next]),
        dotsClass: "slick-dots slick-thumb",
        responsive: [{
            breakpoint: 600,
            settings: {
                arrows: false,
            }
        }]
      };

    const componentSliderSettings = {
        dots: false,
        arrows: false,
        swipe: false
      };

    const onProductSelect = (product, index) => {
        previewSliderRef.current.slickGoTo(index);
        setSelectedProduct(product);
    };


    return <SetoCanvasPage id="musicplaqueMaker" 
                        title="Custom Music Plaque, Order yours in Nepal | Seto Canvas" 
                        metaDescription="Create your custom music plaque, a perfect gift for your loved one with your choice of song and image. Not available in Nepal."
                        turnOffSticky={true} >
                <SCSlider sliderRef={componentSliderRef} sliderSettings={componentSliderSettings} >
                    <div className="flexRow" id="musicPlaqueStyleContainer">
                        <div id="musicPlaquePreviews">
                            <SCSlider sliderRef={previewSliderRef} sliderSettings={previewSliderSettings}>
                                <MusicPlaquePreview product={products[0]} />
                                <MusicPlaquePreview product={products[1]} />
                            </SCSlider>
                        </div>
                        
                        <MusicPlaqueStyleForm selectedProduct={selectedProduct} availableProducts={products}
                                                onProductSelect={onProductSelect} 
                                                onCustomizeNow={() => componentSliderRef.current.slickGoTo(1)} 
                                                onChangeQuantity={(quantity) => setQuantity(quantity)} />
                    </div>

                    <div id="musicPlaqueFormContainer">
                        <Button mui="true" id="goBackBtn" onClick={() => componentSliderRef.current.slickGoTo(0)}><i className="fa fa-arrow-left" aria-hidden="true"></i></Button>
                        <MusicPlaqueForm product={selectedProduct} quantity={quantity}/>
                    </div>
                    
                </SCSlider>
                
                {
                    suggestedProducts &&
                    <SuggestedProducts products={suggestedProducts} 
						        autoplay={true} navigator="arrows" />
                }
	</SetoCanvasPage>
}

export default MusicPlaqueMaker;





// WEBPACK FOOTER //
// ./src/pages/MusicPlaqueMaker.js